import { render, staticRenderFns } from "./Upuserpassd.vue?vue&type=template&id=3ff2907a&scoped=true"
import script from "./Upuserpassd.vue?vue&type=script&lang=js"
export * from "./Upuserpassd.vue?vue&type=script&lang=js"
import style0 from "./Upuserpassd.vue?vue&type=style&index=0&id=3ff2907a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff2907a",
  null
  
)

export default component.exports